import { useEffect } from 'react';

// Track form submissions using HubSpot's tracking script
// This is an internal API that isn't documented anywhere
// But you can see the tracker docs here https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code
export const useTrackHubspotForm = (formId: string, callback?: () => void) => {
  useEffect(() => {
    if (window._hsq) {
      window._hsq.push([
        'trackForm',
        formId,
        {
          onFormSubmit: callback,
        },
      ]);
    }
  }, [formId, callback]);
};
